import React from 'react';
import { array, func, object } from 'prop-types';
import { Col, Row } from 'antd';
import { H3 } from '@seekube-tech/ui-kit';
import { useFormatMessage } from 'react-intl-hooks';
import { JobdatingCard, SearchEvent, TargetFilter } from '@/scenes/Events/scenes/components/JobdatingsExplore/components';
import styles from './styles.less';

const JobdatingsExplore =  ({
  events,
  authUser,
  onSearch,
  onTargetsFilter,
}) => {
  const t = useFormatMessage();

  const handleOnSearchChange = (val) => {
    onSearch(val);
  };

  const handleOnTargetsChange = (val) => {
    onTargetsFilter(val);
  };

  return (
    <div className={styles.jobdatingsExploreContainer}>
      <H3 className="mb-35">{t({ id: 'events.explore.title' })}</H3>

      <div className={styles.top}>
        <TargetFilter targets={authUser?.matching?.targets || []} onTargetsChange={handleOnTargetsChange} />
        <SearchEvent onSearchChange={handleOnSearchChange} />
      </div>
      <div>
        <Row gutter={[25, 41]} className="gutter-row">
          {
            events.map((event) => (
              <Col xs={12} sm={6} md={6} lg={4} key={event._id}>
                <JobdatingCard event={event} authUser={authUser} />
              </Col>
            ))}
        </Row>
      </div>
    </div>
  );
}

JobdatingsExplore.propTypes = {
  events: array,
  authUser: object,
  onSearch: func,
  onTargetsFilter: func,
}

export default JobdatingsExplore;
